<template>
  <div :class="{'nzm-user-info':true}" :style="wrap_style">
    <img class="avatar" :src="user.avatar" @click="login_out" />
    <div class="info" v-if="!user.uuid" @click="login_out">
      <div class="nickname">点击登录</div>
      <div style="margin-top:.05rem;" class="tips">{{tip || '新用户开通会员有优惠哦~'}}</div>
    </div>

    <div class="info" @click="to_uc" v-else>
      <div class="nickname_wrap">
        <div class="nickname">{{nickname}}</div>
        <div :class="{'vip_icon':true,'vip_icon_dark':user.vip_id === 0}">V{{user.level}}</div>
      </div>
      <template v-if="user.vip_id > 0">
        <div class="tips" v-if="user.vip_end_time">有效期：{{user.vip_end_time.split(' ')[0]}}到期</div>
      </template>

      <template v-else>
        <div class="tips">{{tip || '开通会员享大片'}}</div>
      </template>
    </div>

    <div v-if="user.vip_id > 0" class="btn" @click="to_cashier">{{btn_text || '立即续费'}}</div>

    <div v-else class="btn" @click="to_cashier">{{btn_text || '立即开通'}}</div>
  </div>
</template>

<script>
import * as Cookie from 'tiny-cookie'
import click_handler from "../../tools/mgtv/click";
import { login, logout } from "../../tools/mgtv/login";
import { openLink } from "../../tools/mgtv/link";
import { get_dynamic_entry } from "../../api/index";
import { report_urls } from "../../tools/mgtv/analysis";
import { onUseInfoLoad } from "../../tools/onUseInfoLoad";
import { urlToWebp } from '../../tools/tpl';
import { compare_version } from '../../tools/mgtv/version';

export default {
  name: "NzmUserInfo",
  data() {
    return {
      is_app: gact.is_app,
      debug: gact.debug,
      dynamic_info: null
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  created() {
    onUseInfoLoad(() => {
      this.get_dynamic_info();
    }, false);
  },
  computed: {
    user() {
      return window.$bus.user;
    },
    nickname() {
      return window.$bus.user.nickname;
    },
    wrap_style() {
      return {
        background: `url(${urlToWebp(this.info.config.bg_img)}) 0% 0% / 100% 100%`
      };
    },
    tip() {
      if (this.dynamic_info) {
        return this.dynamic_info.tip;
      }
      return "";
    },
    btn_text() {
      if (this.dynamic_info) {
        return this.dynamic_info.btn_text;
      }
      return "";
    }
  },
  methods: {
    login_out() {
      //登录登出
      if (!this.user.uuid) {
        click_handler("用户信息-登录", login);
      } else {
        if (!gact.is_app || gact.debug) {
          click_handler("登出", () => {
            this.$dialog
              .confirm({
                message: "您已登录，是否退出切换账号?"
              })
              .then(logout)
              .catch(() => {
                console.log("取消");
              });
          });
        }
      }
    },
    to_cashier() {
      click_handler(
        "用户信息-立即开通",
        () => {
          let cashier =
            "https://club.mgtv.com/act/mgtv_cashier/index.html?isHideNavBar=1&isFullScreen=1&source=" +
            window.rootdata.act_name +
            "_userinfo_cashier";
          if (this.info.config.cashier) {
            cashier = this.info.config.cashier;
          }
          console.log(this.dynamic_info);
          if (this.dynamic_info && this.dynamic_info.jump_url) {
            cashier = this.dynamic_info.jump_url;
            report_urls(this.dynamic_info.click_report_urls);
          }

          // 离线包AB测临时代码，高版本随机一半开启x-web
          // if(compare_version('>=', '6.7.6')) {
          //   let is_fv = !Cookie.get('_amp_fv_mgtv_cashier');

          //   if (Math.round(Math.random() * 100) <= 50) {
          //       // A
          //       if(is_fv) {
          //         cashier = cashier + '&use-xweb=true&source_uuid=syt_xweb_fv';
          //       } else {
          //         cashier = cashier + '&use-xweb=true&source_uuid=syt_xweb';
          //       }
          //   } else {
          //       // B
          //       if(is_fv) {
          //         cashier = cashier + '&source_uuid=syt_nxweb_fv';
          //       } else {
          //         cashier = cashier + '&source_uuid=syt_nxweb';
          //       }
          //   }
          //   cashier = cashier.replace(/index\.html/, "index2.html")
          // }
          setTimeout(() => {
            openLink(cashier);
          }, 200);
        },
        {
          need_login: false
        }
      );
    },
    to_uc() {
      click_handler(
        "用户信息-用户中心",
        () => {
          setTimeout(() => {
            openLink(
              "https://club.mgtv.com/activity/vipcenter/index.html?isHideNavBar=1&isFullScreen=1&source=vipcenter2019_2020020612_VIPpindao&platform=3"
            );
          }, 200);
        },
        {
          need_login: false
        }
      );
    },
    get_dynamic_info() {
      const entry_source = this.info.config.dynamic_entry_source;
      if (!entry_source) {
        return;
      }
      get_dynamic_entry(entry_source).then(res => {
        /**
       * {
          status: "200",
          msg: "",
          seqid: "d9a1487d85e04d6bb473230e67eb9c27",
          data: {
          click_report_urls: [
          "https://vip.log.mgtv.com/dynamic_entry.html?source=vip_chn_btn&invoker=mobile-android&version=5.1.4&did=i866375028299047&uuid=&vid=&cid=&chnid=&plid=&plan_id=112&exp=&creativity_id=112&type=click"
          ],
          tip: "新用户首月9元",
          show_report_urls: [
          "https://vip.log.mgtv.com/dynamic_entry.html?source=vip_chn_btn&invoker=mobile-android&version=5.1.4&did=i866375028299047&uuid=&vid=&cid=&chnid=&plid=&plan_id=112&exp=&creativity_id=112&type=show"
          ],
          btn_text: "购买VIP",
          close_report_urls: [
          "https://vip.log.mgtv.com/dynamic_entry.html?source=vip_chn_btn&invoker=mobile-android&version=5.1.4&did=i866375028299047&uuid=&vid=&cid=&chnid=&plid=&plan_id=112&exp=&creativity_id=112&type=close"
          ],
          jump_url: "https://www.baidu.com"
          }
        }
       */

        if (!res) {
          return;
        }
        if (res.status === "200") {
          if (res.data.btn_text) {
            this.dynamic_info = res.data;
            report_urls(this.dynamic_info.show_report_urls);
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  @import "../../share/mixins.styl"

  .nzm-user-info
    position relative
    width 7.1rem
    height 1.33rem
    align-items center
    padding 0 .2rem
    display flex
    flex-direction row
    align-items center
    margin 0 auto
    border-radius .08rem

    .avatar
      width .84rem
      height @width
      display block
      position relative
      border 1px solid white
      border-radius 100%
    .info
      display flex
      flex-direction column
      color white
      margin-left .1rem
      .nickname
        font-size .3rem
        color white
        max-width 2rem
        ellipsis()
        @media screen and (min-width: 700px)
          font-size 20PX
      .nickname_wrap
        position relative
        display flex
        align-items center
      .vip_icon
        position relative
        width .58rem
        height .58rem
        background url('https://vipcdn.mgtv.com/upload3/202001/vip_icon.png') no-repeat
        background-size cover
        color #AF600E
        text-align center
        line-height .58rem
        font-size .16rem
      .vip_icon_dark
        background url('https://vipcdn.mgtv.com/upload3/202001/vip_icon_dark.png') no-repeat
        background-size cover
        color #666
      .tips
        font-size .2rem
        color white
        @media screen and (min-width: 700px)
          font-size 14PX

   .btn
      width:1.43rem;
      height:.49rem;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 11px 0px rgba(233,189,107,0.2),0px 2px 3px 0px rgba(244,182,85,1);
      border-radius:25px;
      color:rgba(236,186,98,1) !important;
      font-size:.28rem
      line-height @height
      text-align center
      position absolute
      vcenter()
      right .2rem





</style>
